import { MessageBotEdgeTypesEnum } from "@lib/types/MessageBot";
import DashedEdge from "./DashedEdge";
import { EdgeProps } from "@xyflow/react";

const Edges: Record<MessageBotEdgeTypesEnum, React.FC<EdgeProps>> = {
  [MessageBotEdgeTypesEnum.Dashed]: DashedEdge,
};

export default Edges;
